export default __webpack_public_path__ + "locales/es/RoomLogoCover.json?hash=03512bdb4e637ba1b276ac3b9607e265";